import React, { useEffect, useState } from "react";
import Form from "../../components/form";
import api from "../../services/api";
import ActionTable from "../../components/table/ActionTable";
import { CircularProgress } from "@mui/material";
import { mergeParams } from "../../helpers/helpers";

export default function Lista({ history, location }) {
  const [dados, setDados] = useState(
    mergeParams(
      {
        nome: "",
        exibirInativos: false,
      },
      location
    )
  );
  const [carteiras, setCarteiras] = useState([]);
  const [carregando, setCarregando] = useState(false);

  useEffect(() => {
    carregarCarteiras();
  }, []);

  const carregarCarteiras = (filtrosEnviar = dados) => {
    setDados(filtrosEnviar);
    setCarregando(true);
    api.get("carteiras/listar", filtrosEnviar).then((res) => {
      setCarteiras(res);
      setCarregando(false);
    });
  };

  const filtros = {
    title: "Filtros",
    form: {
      nome: {
        label: "Nome",
        type: "text",
        space: 10,
        value: dados.nome,
      },
      exibirInativos: {
        type: "check",
        label: "Exibir inativas",
        space: 2,
        value: dados.ativas,
      },
    },

    submit: {
      label: "Buscar",
      action: carregarCarteiras,
    },

    urlParams: true,
    history,
    location,
  };

  const abrirDados = (registro) => {
    history.push(`/app/carteira/${registro.id}`);
  };

  const tRegistros = {
    title: "Carteiras",
    onLineClick: abrirDados,
    newItemAction: () => history.push("/app/carteira/0"),
    columns: [
      {
        label: "Nome",
        name: "nome",
      },
      {
        label: "Ativa",
        name: "ativa",
        checkbox: true,
      },
    ],
    array: carteiras,
  };

  return (
    <div>
      <Form formData={filtros} />
      {carregando ? (
        <CircularProgress />
      ) : (
        <ActionTable structure={tRegistros} />
      )}
    </div>
  );
}
